export const CLIENTS = [
  "Alexander M.", "Sophie B.", "Matthias K.", "Elena R.", "Friedrich W.",
  "Isabella T.", "Johannes H.", "Natalia S.", "Sebastian G.", "Miriam L.",
  "Tobias F.", "Valentina C.", "Christian N.", "Anastasia P.", "Maximilian O.",
  "Claudia E.", "Dominik A.", "Francesca V.", "Florian Z.", "Katarina J.",
  "Lukas D.", "Marianna Q.", "Nikolas I.", "Petra Y.", "Rafael X.",
  "Stefania U.", "Thomas B.", "Ursula M.", "Viktor H.", "Wilhelmina S.",
  "Anton K.", "Beatrice R.", "Christoph W.", "Diana T.", "Eduard L.",
  "Franziska G.", "Georg N.", "Helena F.", "Ignaz C.", "Johanna P.",
  "Karl E.", "Laura V.", "Martin Z.", "Nicole J.", "Oskar X.",
  "Patricia D.", "Quentin I.", "Rosa Y.", "Stefan U.", "Theresa B.",
  "Ulrich M.", "Veronika H.", "Walter S.", "Xenia K.", "Yannis R.",
  "Zoe W.", "Aleksander T.", "Brigitte L.", "Cesare G.", "Dorota N.",
  "Ernst F.", "Flavia C.", "Gerhard P.", "Hanna E.", "Ivan V.",
  "Julia Z.", "Klaus J.", "Leonie X.", "Michal D.", "Nora I.",
  "Otto Y.", "Petra U.", "Quintus B.", "Renata M.", "Sigrid H.",
  "Tomas S.", "Uwe K.", "Valeria R.", "Werner W.", "Xaver T.",
  "Yvonne L.", "Zdravko G.", "Alena N.", "Boris F.", "Carla C.",
  "Dimitri P.", "Eva E.", "Felix V.", "Greta Z.", "Hans J.",
  "Irene X.", "Joachim D.", "Kira I.", "Leon Y.", "Marta U.",
  "Nicolai B.", "Olga M.", "Pavel H.", "Queenie S.", "Robert K.",
  "Amelia W.", "Bruno S.", "Caterina L.", "Dario M.", "Elisa F.",
  "Fabian R.", "Giulia T.", "Hugo N.", "Ines C.", "Jakub P.",
  "Klara V.", "Luca E.", "Monika Z.", "Nils B.", "Oana H.",
  "Piotr K.", "Quirina D.", "Radu J.", "Sabrina X.", "Teodor I.",
  "Uma Y.", "Vasile U.", "Wanda G.", "Xander Q.", "Yara F.",
  "Zara C.", "Adrien M.", "Bianca S.", "Cosmin L.", "Delia R.",
  "Emilio T.", "Fiona N.", "Gregor P.", "Hilde V.", "Ioana E.",
  "Jens Z.", "Katja B.", "Lena H.", "Marco K.", "Nina D.",
  "Oleg J.", "Polina X.", "Remi I.", "Sonia Y.", "Timur U.",
  "Ursula G.", "Vera Q.", "Wilhelm F.", "Xiu C.", "Yolanda M.",
  "Zeno S.", "Adela L.", "Bogdan R.", "Crina T.", "Denis N.",
  "Eleonora P.", "Florin V.", "Gabi E.", "Horst Z.", "Iolanda B.",
  "Jovan H.", "Kristina K.", "Liviu D.", "Marius J.", "Nadia X.",
  "Octavian I.", "Pamela Y.", "Rares U.", "Simona G.", "Tudor Q.",
];

export const PROFIT_OPTIONS = [
  { label: "29%", amount: 2700 },
  { label: "37%", amount: 5800 },
  { label: "49%", amount: 9800 },
];

// Legacy exports for backward compatibility
export const EUROPEAN_NAMES = CLIENTS;
export const INVESTMENT_AMOUNTS = PROFIT_OPTIONS.map((p) => p.amount);
export const PROFIT_LABELS = PROFIT_OPTIONS.map((p) => p.label);
